import { render } from "./comp_Paginate.vue?vue&type=template&id=4176ab26&scoped=true"
import script from "./comp_Paginate.vue?vue&type=script&lang=js"
export * from "./comp_Paginate.vue?vue&type=script&lang=js"

import "./comp_Paginate.vue?vue&type=style&index=0&id=4176ab26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4176ab26"]])

export default __exports__